import React from 'react';
import { Layout } from 'antd';
import './style.css';

const { Footer: AntFooter } = Layout;

const getCurrentYear = () => new Date().getFullYear();

const Footer = () => (
  <AntFooter className="page-footer">
    <div className="CopyWrites" key="FooterCopyWrites">
      <span className="TuringTitle">Turing</span>
      <span>©{getCurrentYear()}</span>
    </div>
  </AntFooter>
);

export default Footer;
